export default __webpack_public_path__ + "static/media/ctaBg.73da667b.png";